var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "style=linear"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 21059"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4119 2.7702L3.47998 13.2828C3.10497 13.682 2.74205 14.4683 2.66946 15.0127L2.22186 18.9323C2.0646 20.3476 3.08077 21.3154 4.48406 21.0735L8.3794 20.4081C8.92378 20.3113 9.68594 19.9121 10.061 19.5008L19.9929 8.98822C21.7107 7.17363 22.4849 5.10498 19.8114 2.57664C17.15 0.0725007 15.1297 0.955605 13.4119 2.7702Z",
    stroke: "#008556",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.7546 4.52441C12.2748 7.86327 14.9846 10.4158 18.3477 10.7545",
    stroke: "#008556",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1 25.0293H22.7752",
    stroke: "#008556",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenameIcon);
export default __webpack_public_path__ + "static/media/rename-icon.919334bb9fdb7af99988b6c40c22d7a8.svg";
export { ForwardRef as ReactComponent };